module.exports = __webpack_public_path__ + "media/components/country-flag/static/li-32f4f28fbb3051b42e4595aefc0d3219.svg";